import { Component, Host, h, Prop, Watch, State, Event, EventEmitter, Element, Fragment, Listen } from '@stencil/core';
import { deepParse } from '../../services';
import { ButtonAppearance } from '../rcm-button/rcm-button.types';

export interface Section {
  id: string;
  title: string;
}

@Component({
  tag: 'rcm-content-navigation',
  styleUrl: 'rcm-content-navigation.scss',
  shadow: true,
})
export class RcmContentNavigation {
  @Prop() headline: string;

  @Prop({ mutable: true }) sections: string | Section[];

  @State() isPinned = false;

  @State() isSearchOpen = false;

  @Event() pinningToNavigationEvent: EventEmitter;

  @Element() el: HTMLElement;

  componentWillLoad() {
    if (typeof this.sections === 'string') {
      this.sections = deepParse(this.sections);
    }
  }

  @Watch('sections')
  updateTeasers() {
    if (typeof this.sections === 'string') {
      this.sections = deepParse(this.sections);
    }
  }

  @Watch('isPinned')
  watchIsPinnedHandler(newValue: boolean) {
    this.pinningToNavigationEvent.emit({ pinned: newValue });
  }

  @Listen('toggleSearchEvent', {
    target: 'window',
  })
  updateSearchOpen(e) {
    this.isSearchOpen = e.detail.searchOpen;
  }

  componentDidRender() {
    const contentNavigation = this.el.shadowRoot.querySelector('.sticky-top');
    window.addEventListener('scroll', () => {
      const position = contentNavigation.getBoundingClientRect();
      this.isPinned = position.top <= 160;
    });
  }

  renderNavigation() {
    return (
      <Fragment>
        <div class="content-navigation">
          {(this.sections as Section[]).map((section) => (
            <rcm-button
              appearance={ButtonAppearance.UNDERLINE_ICON}
              text={section.title}
              icon="circle"
              key={section.id}
              link={`#${section.id}`}
              fontRegular={true}
              iconSize={10}
              parentComponent="rcm-content-navigation"
            ></rcm-button>
          ))}
        </div>
      </Fragment>
    );
  }

  render() {
    return (
      <Host>
        <rcm-container>
          <rcm-headline level={4} headline={this.headline} bold={true}></rcm-headline>
          <div
            class={{
              'sticky-top': true,
            }}
          >
            {this.renderNavigation()}
          </div>
        </rcm-container>
        <div
          class={{
            'fixed-header': true,
            'is-pinned': this.isPinned && !this.isSearchOpen,
          }}
        >
          <rcm-container fullWidthMobile>{this.renderNavigation()}</rcm-container>
        </div>
      </Host>
    );
  }
}
